import Box from "@mui/material/Box";

import DeveloperPanels from "@/components/marketing/DeveloperPanels";
import { WHY_BLOCK, WhyBlockHeading } from "./WhySupport";
import { DEVELOPER } from "./homeContent";

export default function WhyDeveloper() {
  return (
    <Box sx={WHY_BLOCK}>
      <WhyBlockHeading heading={DEVELOPER.heading} body={DEVELOPER.body} />
      <DeveloperPanels
        apiCard={DEVELOPER.apiCard}
        apiCta={DEVELOPER.apiCta}
        integrationsCta={DEVELOPER.integrationsCta}
        rows={DEVELOPER.marquees}
      />
    </Box>
  );
}
